const HEALTH_STORAGE_PREFIX = 'abakus.integrationHealth';
const FEATURE_STORAGE_PREFIX = 'abakus.enableThirdPartyIntegration';

function readSessionItem(key: string): string | null {
    try {
        return sessionStorage.getItem(key);
    } catch {
        return null;
    }
}

function writeSessionItem(key: string, value: string) {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        // Ignore quota / private-mode failures.
    }
}

function removeSessionItem(key: string) {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // Ignore storage access failures.
    }
}

function scopedStorageKey(prefix: string, organisationId: string | null | undefined): string | null {
    const id = typeof organisationId === 'string' ? organisationId.trim() : '';
    if (!id)
        return null;

    return `${prefix}.${encodeURIComponent(id)}`;
}

function removeMatchingSessionKeys(prefix: string) {
    try {
        const keysToRemove: string[] = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key === prefix || key?.startsWith(`${prefix}.`))
                keysToRemove.push(key);
        }

        keysToRemove.forEach(removeSessionItem);
    } catch {
        // Ignore storage access failures.
    }
}

export function readCachedIntegrationHealth<T>(organisationId: string | null | undefined): T[] {
    const key = scopedStorageKey(HEALTH_STORAGE_PREFIX, organisationId);
    if (!key)
        return [];

    const raw = readSessionItem(key);
    if (!raw)
        return [];

    try {
        const parsed = JSON.parse(raw) as unknown;
        return Array.isArray(parsed) ? parsed as T[] : [];
    } catch {
        return [];
    }
}

export function writeCachedIntegrationHealth(organisationId: string | null | undefined, items: unknown[]) {
    const key = scopedStorageKey(HEALTH_STORAGE_PREFIX, organisationId);
    if (!key)
        return;

    writeSessionItem(key, JSON.stringify(items));
}

export function readCachedEnableThirdPartyIntegration(organisationId: string | null | undefined): boolean {
    const key = scopedStorageKey(FEATURE_STORAGE_PREFIX, organisationId);
    if (!key)
        return false;

    return readSessionItem(key) === 'true';
}

export function writeCachedEnableThirdPartyIntegration(
    organisationId: string | null | undefined,
    enabled: boolean
) {
    const key = scopedStorageKey(FEATURE_STORAGE_PREFIX, organisationId);
    if (!key)
        return;

    writeSessionItem(key, enabled ? 'true' : 'false');
}

export function clearIntegrationToolbarCache() {
    removeMatchingSessionKeys(HEALTH_STORAGE_PREFIX);
    removeMatchingSessionKeys(FEATURE_STORAGE_PREFIX);
}
